import React from "react";
import { MessageCircle } from "lucide-react";
import { useSite } from "@/i18n/SiteContext";
import { waLink } from "@/lib/api";

export const WhatsAppButton = () => {
  const { t, settings } = useSite();
  if (!settings.whatsapp) return null;
  return (
    <a
      href={waLink(settings.whatsapp, t("wa.default"))}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t("wa.aria")}
      data-testid="whatsapp-floating-button"
      className="fixed bottom-6 right-6 z-50 group flex items-center gap-3"
    >
      <span className="hidden md:block opacity-0 group-hover:opacity-100 translate-x-2 group-hover:translate-x-0 bg-white text-ocean text-sm font-medium px-4 py-2 rounded-full shadow-soft" style={{ transition: "opacity .25s ease, transform .25s ease" }}>
        {t("wa.chat")}
      </span>
      <span className="w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg whatsapp-pulse">
        <MessageCircle size={26} className="text-white" fill="white" />
      </span>
    </a>
  );
};
